import { api } from '@goaltree/backend/convex/_generated/api'
import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { useMutation } from 'convex/react'

import { removeNode } from '@/lib/nodes-optimistic'

export function useDeleteNode() {
  const remove = useMutation(api.nodes.remove).withOptimisticUpdate((localStore, { nodeId }) =>
    removeNode(localStore, nodeId),
  )
  return (nodeId: Id<'nodes'>) => remove({ nodeId })
}
